type FetchRemoteFileOptions = {
  timeoutMs?: number;
};

export function extractFileNameFromUrl(url: string, fallback = 'arquivo') {
  try {
    const cleanUrl = url.split('?')[0];
    const lastSegment = cleanUrl.split('/').filter(Boolean).pop();
    return lastSegment || fallback;
  } catch {
    return fallback;
  }
}

export async function fetchRemoteFile(url: string, options: FetchRemoteFileOptions = {}) {
  const { timeoutMs = 10000 } = options;
  const controller = new AbortController();
  const timeoutId = window.setTimeout(() => controller.abort(), timeoutMs);

  try {
    let response: Response;

    try {
      response = await fetch(url, {
        method: 'GET',
        signal: controller.signal,
      });
    } catch {
      throw new Error('NETWORK_ERROR');
    }

    if (!response.ok) {
      throw new Error(`HTTP_${response.status}`);
    }

    const contentType = response.headers.get('content-type')?.toLowerCase() || '';

    if (contentType.includes('xml')) {
      throw new Error('XML_ERROR');
    }

    const blob = await response.blob();

    if (!blob.size) {
      throw new Error('EMPTY_FILE');
    }

    return {
      blob,
      contentType,
    };
  } finally {
    window.clearTimeout(timeoutId);
  }
}
